import styled from 'styled-components';
import { Input } from '@hqo/react-components-library';

export const StyledInput = styled(Input)`
  margin-bottom: 29px;
`;
